import { inject, Injector } from '@angular/core';
import { AnalyticsManager } from '../analytics-manager';
import { ClarityProvider } from '../providers/clarity-provider';
import { AmplitudeProvider } from '../providers/amplitude-provider';

export function initializeAnalytics() {
  const analyticsManager = inject(AnalyticsManager);
  const injector = inject(Injector);

  return () => {
    analyticsManager.registerProvider(new ClarityProvider());
    analyticsManager.registerTrackerProvider(new AmplitudeProvider(injector));
  };
}
